import * as qs from "qs";
import { Settings, VirtualBotoneraType } from "../Settings";
import { ISize } from "../MyHelpers";

interface QueryConfig
{
    monitors: ConfigMonitor[]
};

interface ConfigMonitor
{
    output: string;
    w: string;
    h: string;
    x: string;
    y: string;
    rotate: "normal" | "left" | "right" | "inverted",
    type: "primary" | "botonera" | "other"
}


export interface ScreenConfig
{
    SuperScreen: ISize;
    GameScreen: ISize;
    BotoneraScreen?: ISize;
    
    Screens: number;

    ScaleX: number;
    ScaleY: number;

    AspectFixY: number;
}

let screenConfigCache: ScreenConfig = null;

export function ParseMonitors(): ScreenConfig
{
    if (screenConfigCache != null)
    {
        return screenConfigCache;
    }

    let exampleConfig = {
		"c": {
			"monitors": [
				{
					"output": "HDMI1",
					"w": 1920,
					"h": 1080,
					"x": 0,
					"y": 0,
					"rotate": "left",
					"type": "other"
				},
				{
					"output": "HDMI2",
					"w": 1280,
					"h": 390,
					"x": 0,
					"y": 1920,
					"rotate": "normal",
					"type": "botonera",
					//"touchinput": "/dev/input/by-id/usb-ILITEK_Multi-Touch-V5000-event-if00"
				}
			],
		}
	};

    console.log("Example config", exampleConfig);

    const exampleConfigStr = JSON.stringify(exampleConfig);
    console.log("Example config str", exampleConfigStr);


	const parsedConfig: QueryConfig = qs.parse(window.location.search, {ignoreQueryPrefix: true, allowDots: true}) as unknown as QueryConfig;
	console.log("Parsed config", parsedConfig);

    let screenConfig: ScreenConfig = {
        SuperScreen: {Width: Settings.ScreenWidth, Height: Settings.ScreenHeight * Settings.Screens},
        GameScreen: {Width: Settings.ScreenWidth, Height: Settings.ScreenHeight * Settings.Screens},
        Screens: Settings.Screens,
    } as ScreenConfig

    // take into accounting virtual botonera screen
    if (Settings.VirtualBotoneraType != VirtualBotoneraType.Disable)
    {
        screenConfig.SuperScreen = {
            Height: screenConfig.SuperScreen.Height + Settings.bottoneraFakeSize.Height,
            Width: Math.max(Settings.ScreenWidth, Settings.bottoneraFakeSize.Width)
        };

        screenConfig.Screens += 1;
    }

    screenConfig.ScaleX = 1; //(screenConfig.GameScreen.width / screenConfig.GameScreen.width);
	screenConfig.ScaleY = 1; //(screenConfig.GameScreen.height / screenConfig.GameScreen.height);
    screenConfig.AspectFixY = screenConfig.ScaleY / screenConfig.ScaleX;


	let parsedMonitors = parsedConfig?.monitors;
	if (!parsedMonitors)
    {
        return screenConfig
    }

    const originalGameScreenWidth = screenConfig.GameScreen.Width;
    const originalGameScreenHeight = screenConfig.GameScreen.Height;

    // todo
    // there should only be one botonera monitor
    // {

    // 	if (parsedMonitors.filter(m => m.type == "botonera").length > 1)
    // 		api.frontendError(FrontendErrorCode.UnknownFrontendError, "Only 1 botonera monitor allowed");
    // 	else if (!!parsedMonitors.find(m => m.type == "botonera") != (Settings.VirtualBotoneraType != VirtualBotoneraType.Disable))
    // 		api.frontendError(FrontendErrorCode.UnknownFrontendError, "Botonera in machine config and in settings does not match")
    // }

    // if there is botonera type monitor, it is the bottom most monitor
    {

    }

    screenConfig.SuperScreen =
    {
        Width: Math.max(...parsedMonitors.map(m => m.rotate == "normal" || m.rotate == "inverted" ? parseInt(m.x) + parseInt(m.w) : parseInt(m.y) + parseInt(m.h))),
        Height: Math.max(...parsedMonitors.map(m => m.rotate == "normal" || m.rotate == "inverted" ? parseInt(m.y) + parseInt(m.h) : parseInt(m.x) + parseInt(m.w))),
    };
    
    

    // superscreen.style.width = superScreenWidth + "px";
    // superscreen.style.height = superScreenHeight + "px";
    // find total size of monitors without bottonera

    let gameMonitors = parsedMonitors.filter(m => m.type != "botonera");

    // TODO
    // find monitor with max x, gameMonitor.width = x + width
    console.log("game monitors", gameMonitors);

    screenConfig.GameScreen = {
        Width: Math.max(...gameMonitors.map(m => m.rotate == "normal" || m.rotate == "inverted" ? parseInt(m.x) + parseInt(m.w) : parseInt(m.y) + parseInt(m.h))),
        Height: Math.max(...gameMonitors.map(m => m.rotate == "normal" || m.rotate == "inverted" ? parseInt(m.y) + parseInt(m.h) : parseInt(m.x) + parseInt(m.w))),
    };

    screenConfig.ScaleX = (screenConfig.GameScreen.Width / originalGameScreenWidth);
	screenConfig.ScaleY = (screenConfig.GameScreen.Height / originalGameScreenHeight);
    screenConfig.AspectFixY = screenConfig.ScaleX / screenConfig.ScaleY;

    console.log(`GameScreen: ${screenConfig.GameScreen.Width}x${screenConfig.GameScreen.Height}, scale: ${screenConfig.ScaleX}x${screenConfig.ScaleY}, aspectFixY: ${screenConfig.AspectFixY}`);

    screenConfigCache = screenConfig;
    return screenConfigCache;
}